/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */

export type AidModelCalculationRequestCalculationGiftTargetType =
  (typeof AidModelCalculationRequestCalculationGiftTargetType)[keyof typeof AidModelCalculationRequestCalculationGiftTargetType];

export const AidModelCalculationRequestCalculationGiftTargetType = {
  COA: 'COA',
  DIRECT: 'DIRECT',
  TUITION: 'TUITION',
} as const;
